import { render, staticRenderFns } from "./drawerTianjiawuliao.vue?vue&type=template&id=17166a49&scoped=true&"
import script from "./drawerTianjiawuliao.vue?vue&type=script&lang=js&"
export * from "./drawerTianjiawuliao.vue?vue&type=script&lang=js&"
import style0 from "./drawerTianjiawuliao.vue?vue&type=style&index=0&id=17166a49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17166a49",
  null
  
)

export default component.exports